import {
    addProfile,
    CamelCaseNamingConvention,
    createMapper,
} from '@automapper/core';
import { IQueryParamsMetadata, IQueryParamsSymbol } from '@pf/shared-common';
import {
    ResourceAuthMetadataMap,
    withResourceAuthMetadata,
    withTypeEntityMetadata,
    withUserFragmentMetadata,
} from '@pf/shared/util-platform';

import { pojos } from '@automapper/pojos';
import { withMetadata } from '@pf/shared-utility';
import { ZoneMetadataMap } from './zones/zone.mapping-profile';
import { SlotMetadataMap } from './slots/slot.mapping-profile';
import { WarehouseMetadataMap } from './warehouses/warehouse.mapping-profile';
import { ContainerMetadataMap } from './containers/container.mapping-profile';
import { PickListMetadataMap } from './pick-lists/pick-list.mapping-profile';
import { PickMetadataMap } from './picks/pick.mapping-profile';
import { ProjectMetadataMap } from './projects/project.mapping-profile';
import { ProjectLineItemMetadataMap } from './project-line-items/project-line-item.mapping-profile';
import { InventoryBundleMetadataMap } from './inventory-bundles/inventory-bundle.mapping-profile';
import { ExceptionMetadataMap } from './exceptions/exception.mapping-profile';
import { AuditMetadataMap } from './audits/audit.mapping-profile';
import { InventoryAdjustmentMetadataMap } from './inventory-adjustments/inventory-adjustment.mapping-profile';
import { EquipmentTypeMetadataMap } from './equipment-types/equipment-type.mapping-profile';
import { EquipmentMetadataMap } from './equipments/equipment.mapping-profile';
import { ReplenishmentMetadataMap } from './replenishments/replenishment.mapping-profile';
import { AsnHeaderMetadataMap } from './asn-headers/asn-header.mapping-profile';
import { AsnLineMetadataMap } from './asn-lines/asn-line.mapping-profile';
import { ReceiptHeaderMetadataMap } from './receipt-headers/receipt-header.mapping-profile';
import { ReceiptLineMetadataMap } from './receipt-lines/receipt-line.mapping-profile';
import { RequisitionMetadataMap } from './requisitions/requisition.mapping-profile';
import { RequisitionLineMetadataMap } from './requisition-lines/requisition-line.mapping-profile';
import { ShipmentMetadataMap } from './shipments/shipment.mapping-profile';
import { PackingListMetadataMap } from './packing-lists/packing-list.mapping-profile';
import { PackLineMetadataMap } from './pack-lines/pack-line.mapping-profile';
import { PutAwayListMetadataMap } from './put-away-lists/put-away-list.mapping-profile';
import { PutAwayMetadataMap } from './put-away-lists/put-away.mapping-profile';
import { WarehouseItemSettingsMetadataMap } from './warehouse-item-settings/warehouse-item-setting.mapping-profile';

/** Global Metadata */
withMetadata(IQueryParamsSymbol, IQueryParamsMetadata);
withTypeEntityMetadata();
withResourceAuthMetadata();
withUserFragmentMetadata();

/** Create mapper */
export const PlatformWmsMapper = createMapper({
    strategyInitializer: pojos(),
    namingConventions: new CamelCaseNamingConvention(),
});

/** Add mapping profiles */
addProfile(PlatformWmsMapper, ResourceAuthMetadataMap.profile);
addProfile(PlatformWmsMapper, ZoneMetadataMap.profile);
addProfile(PlatformWmsMapper, SlotMetadataMap.profile);
addProfile(PlatformWmsMapper, WarehouseMetadataMap.profile);
addProfile(PlatformWmsMapper, ContainerMetadataMap.profile);
addProfile(PlatformWmsMapper, PickListMetadataMap.profile);
addProfile(PlatformWmsMapper, PickMetadataMap.profile);
addProfile(PlatformWmsMapper, ProjectLineItemMetadataMap.profile);
addProfile(PlatformWmsMapper, ProjectMetadataMap.profile);
addProfile(PlatformWmsMapper, InventoryBundleMetadataMap.profile);
addProfile(PlatformWmsMapper, ExceptionMetadataMap.profile);
addProfile(PlatformWmsMapper, InventoryAdjustmentMetadataMap.profile);
addProfile(PlatformWmsMapper, EquipmentTypeMetadataMap.profile);
addProfile(PlatformWmsMapper, EquipmentMetadataMap.profile);
addProfile(PlatformWmsMapper, ReplenishmentMetadataMap.profile);
addProfile(PlatformWmsMapper, AuditMetadataMap.profile);
addProfile(PlatformWmsMapper, AsnHeaderMetadataMap.profile);
addProfile(PlatformWmsMapper, AsnLineMetadataMap.profile);
addProfile(PlatformWmsMapper, ReceiptHeaderMetadataMap.profile);
addProfile(PlatformWmsMapper, ReceiptLineMetadataMap.profile);
addProfile(PlatformWmsMapper, RequisitionMetadataMap.profile);
addProfile(PlatformWmsMapper, RequisitionLineMetadataMap.profile);
addProfile(PlatformWmsMapper, PackingListMetadataMap.profile);
addProfile(PlatformWmsMapper, PackLineMetadataMap.profile);
addProfile(PlatformWmsMapper, ShipmentMetadataMap.profile);
addProfile(PlatformWmsMapper, PutAwayListMetadataMap.profile);
addProfile(PlatformWmsMapper, PutAwayMetadataMap.profile);
addProfile(PlatformWmsMapper, WarehouseItemSettingsMetadataMap.profile);
